export const reloadPageController = {
  reloadPage() {
    window.location.reload()
  },
}
